import React from "react";
import PropTypes from "prop-types";
import { errorLogService } from "../services/errorLogService";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Registrar error en el backend
    errorLogService.logError(error, {
      component: this.props.componentName || "Unknown",
      componentStack: errorInfo.componentStack,
      errorBoundary: true,
    });

    // Log en consola para desarrollo
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            padding: "20px",
            backgroundColor: "#f5f5f5",
            textAlign: "center",
          }}
        >
          <div
            style={{
              maxWidth: "600px",
              padding: "40px",
              backgroundColor: "white",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <h1 style={{ color: "#e74c3c", marginBottom: "20px" }}>
              Algo salió mal
            </h1>
            <p style={{ color: "#666", marginBottom: "30px", lineHeight: "1.6" }}>
              Ha ocurrido un error inesperado. El error ha sido reportado
              automáticamente a nuestro equipo.
            </p>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
              <button
                onClick={this.handleReload}
                style={{
                  padding: "12px 24px",
                  backgroundColor: "#3498db",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                Recargar página
              </button>
              <button
                onClick={this.handleGoHome}
                style={{
                  padding: "12px 24px",
                  backgroundColor: "#95a5a6",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                Ir al inicio
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  componentName: PropTypes.string,
  children: PropTypes.node,
};

export default ErrorBoundary;
